import React, { useEffect, useState } from "react";

import {
  Checkbox,
  CheckboxChangeParams,
  DropdownChangeParams,
} from "primereact";

import { WithContext as ReactTags } from "react-tag-input";
import { RiEyeFill, RiEyeOffFill } from "react-icons/ri";

import "./reactTagInputStyle.css";
import { theme } from "../../styles/theme";
import Icons from "../icons-helper";

import {
  ButtonInput,
  CheckboxStyled,
  CheckboxToggle,
  DownloadButton,
  DropdownStyled,
  ErrorStyled,
  ErrorStyledRecoveryPassword,
  FieldSeclectStyled,
  FieldStyled,
  FileContainer,
  FileInfo,
  FileStyled,
  InpuImasktStyled,
  InputStyled,
  LabelRadioStyled,
  LabelStyled,
  NumberInputContainer,
  RadioBox,
  RadioStyled,
  TextAreaStyled,
  ToogleButtonStyled,
  ToogleStyled,
  ViewPass,
} from "./styled";
import TooltipComp from "../tooltip-info-field";

const MakeField = ({
  field,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  handleCustomChange,
}: any): JSX.Element => {
  const [viewPass, setViewPass] = useState<boolean>(false);
  const [currentValue, setCurrentValue] = useState<any>();

  const [tags, setTags] = useState<any>([]);

  const KeyCodes = {
    comma: 188,
    enter: 13,
  };
  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  const handleDelete = (i: number): void => {
    const arrayWithNewTag = tags.filter(
      (tag: any, index: number) => index !== i,
    );

    const string = arrayWithNewTag.map((item: any) => item.text).join(", ");

    setTags(arrayWithNewTag);
    setCurrentValue(arrayWithNewTag);
    setFieldValue(field.name, string);
  };

  const handleAddition = (tag: any): void => {
    setTags([...tags, tag]);
    const arrayWithNewTag = [...tags, tag];
    const string = arrayWithNewTag.map((item) => item.text).join(", ");
    handleChange(field.name);
    setCurrentValue([...tags, tag]);
    setFieldValue(field.name, string);
    if (field.onChange) {
      field.onChange(string);
    }
  };

  const handleDrag = (tag: any, currPos: any, newPos: any): void => {
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    // re-render
    setTags(newTags);
  };

  const handleTagClick = (index: any): void => {
    console.log("The tag at index was clicked", index);
  };

  useEffect(() => {
    if (
      field.defaultValue &&
      field?.type !== "checkboxGroup" &&
      field?.type !== "multipleValueText"
    ) {
      setTimeout(() => {
        setFieldValue(field.name, field.defaultValue);
      }, 50);
    }

    if (field.defaultValue && field.type === "select") {
      setTimeout(() => {
        handleChange(field.name);
        setFieldValue(field.name, field.defaultValue);
      }, 50);
    }

    if (field.value && field.type === "select") {
      setTimeout(() => {
        handleChange(field.name);
        setFieldValue(field.name, field.value);
      }, 50);
    }

    if (
      field?.type === "checkboxGroup" &&
      Object.values(field?.defaultValue)?.length
    ) {
      setTimeout(() => {
        handleChange(field.name);
        setFieldValue(field.name, field.defaultValue);
      }, 50);
    }

    if (
      field?.defaultValue &&
      field?.type !== "checkboxGroup" &&
      field?.type !== "multipleValueText"
    ) {
      setCurrentValue(field?.defaultValue);
    }

    if (
      field?.type === "checkboxGroup" &&
      Object.values(field?.defaultValue)?.length
    ) {
      setCurrentValue(field?.defaultValue);
    }

    if (field?.type === "multipleValueText" && field?.defaultValue?.length) {
      setCurrentValue(field?.defaultValue);
      setTags(field?.defaultValue);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.defaultValue, field.name, setFieldValue, field.disabled]);

  if (field?.type === "file") {
    return (
      <FileContainer className="container-field">
        <CheckboxStyled key={field.name} className="file-content">
          {field.label && (
            <LabelStyled>
              {field.label}
              <input
                accept={field?.accept}
                name={field.name}
                type={field.type}
                hidden
                disabled={field.disabled}
                placeholder={field.placeholder}
                onBlur={handleBlur}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file =
                    (!!e?.target?.files && e?.target?.files[0]) || null;
                  setFieldValue(`${field.name}`, file);
                  handleChange(field.name);
                  setCurrentValue(!!e?.target?.files && e?.target?.files[0]);
                  const reader = new FileReader();
                  if (file) {
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                      setFieldValue(`${field.name}_file`, reader.result);
                    };
                    reader.onerror = (error) => {
                      console.error("Error: ", error);
                    };
                  }
                  if (field.onChange) {
                    field.onChange(file);
                  }
                }}
              />
              <FileStyled>
                <Icons
                  name={field?.icon || "file-pdf"}
                  width={20}
                  height={20}
                  color={theme.colors.darkGray}
                />
                <FileInfo>
                  <p>
                    {currentValue?.name ||
                      (typeof currentValue === "string"
                        ? "Trocar arquivo"
                        : field?.placeholder)}
                  </p>
                  {currentValue && (
                    <>
                      {currentValue?.size && (
                        <span>
                          {(currentValue?.size / 1000).toFixed(2)}
                          KB
                        </span>
                      )}
                    </>
                  )}
                </FileInfo>

                {typeof currentValue === "string" && (
                  <DownloadButton target="_blank" href={currentValue}>
                    <Icons
                      name="download"
                      width={20}
                      height={20}
                      color={theme.colors.darkGray}
                    />
                  </DownloadButton>
                )}
              </FileStyled>
            </LabelStyled>
          )}
        </CheckboxStyled>
        {errors[field.name] && (
          <ErrorStyled className="error-field-file">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FileContainer>
    );
  }
  if (field?.type === "select") {
    return (
      <FieldSeclectStyled className="container-field">
        {field.label && (
          <LabelStyled
            className="label-input select-tooltip"
            key={field.name}
            htmlFor={field.name}
          >
            {" "}
            {field.label}
            {field?.needsTooltip && <TooltipComp message={field?.tooltip} />}
            {field?.required && <span className="required">*</span>}
          </LabelStyled>
        )}
        <DropdownStyled
          id={field.name}
          name={field.name}
          disabled={field.disabled}
          options={field?.options}
          onHide={() => {
            const formRef: HTMLElement | null = document.getElementById("root");
            if (formRef) {
              formRef.classList.remove("openSelect");
            }
          }}
          placeholder={field?.placeholder}
          optionLabel={field?.labelKey || "label"}
          optionValue={field?.valueKey || "value"}
          value={currentValue || field?.defaultValue || field?.value || ""}
          onChange={(e: DropdownChangeParams) => {
            console.log("The value", e.target.value);
            setFieldValue(field.name, e.target.value);
            handleChange(e.target.name);
            setCurrentValue(e.target.value);
            if (field?.onChange) {
              field?.onChange(e);
            }
          }}
          appendTo="self"
        />
        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldSeclectStyled>
    );
  }
  if (field?.type === "component") {
    return field.component();
  }
  if (field?.type === "radio") {
    return (
      <RadioStyled key={field.name} className="container-field">
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        {field?.options?.map(
          (el: any): JSX.Element => (
            <React.Fragment key={el.label}>
              {el.label && (
                <LabelRadioStyled>
                  <RadioBox
                    name={field.name}
                    value={el.value}
                    type={field.type}
                    disabled={field.disabled}
                    placeholder={field.placeholder}
                    onBlur={handleBlur}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      handleChange(field.name);
                      setCurrentValue(e.target.value);
                      setFieldValue(field.name, e.target.value);
                      if (field.onChange) {
                        field.onChange(e.target.value);
                      }
                    }}
                  />
                  {el.label}
                </LabelRadioStyled>
              )}
            </React.Fragment>
          ),
        )}
        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </RadioStyled>
    );
  }
  if (field?.type === "checkboxGroup") {
    return (
      <CheckboxStyled className="d-flex flex-column container-field">
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        <div className="d-flex flex-wrap w-100 mt-3 checkbox-container">
          {field?.options?.map(
            (el: any): JSX.Element => (
              <div
                className="w-25 d-flex mb-4 align-items-center"
                key={el.name}
              >
                <Checkbox
                  name={field.name}
                  checked={currentValue && currentValue[el?.value]}
                  type="checkbox"
                  disabled={field.disabled}
                  placeholder={field.placeholder}
                  onBlur={handleBlur}
                  onChange={(e: CheckboxChangeParams) => {
                    handleChange(field.name);
                    setCurrentValue({
                      ...currentValue,
                      [el.value]: e.target.checked,
                    });
                    setFieldValue(field.name, {
                      ...currentValue,
                      [el.value]: e.target.checked,
                    });
                    if (field.onChange) {
                      field.onChange(e);
                    }
                  }}
                />
                {field.label && (
                  <LabelStyled className="label-checkbox m-0 ms-2">
                    {el.label}
                  </LabelStyled>
                )}
                {errors[field.name] && (
                  <ErrorStyled>{errors[field.name]}</ErrorStyled>
                )}
              </div>
            ),
          )}
        </div>
      </CheckboxStyled>
    );
  }
  if (field?.type === "checkbox") {
    return (
      <CheckboxStyled
        className="checkbox container-field"
        style={{
          height: "60px",
        }}
      >
        <Checkbox
          name={field.name}
          checked={currentValue || field.defaultValue}
          type={field.type}
          disabled={field.disabled}
          placeholder={field.placeholder}
          onBlur={handleBlur}
          onChange={(e: CheckboxChangeParams) => {
            handleChange(field.name);
            setCurrentValue(e.target.checked);
            if (handleCustomChange) {
              handleCustomChange(e);
            }

            setFieldValue(field.name, e.target.checked);
            if (field.onChange) {
              field.onChange(e.target.value);
            }
          }}
        />
        {field.label && (
          <LabelStyled className="label-checkbox m-0 ms-2 checkbox-tooltip">
            {field.label}
          </LabelStyled>
        )}
        {errors[field.name] && <ErrorStyled>{errors[field.name]}</ErrorStyled>}
        {field?.needsTooltip && <TooltipComp message={field?.tooltip} />}
      </CheckboxStyled>
    );
  }

  if (field?.type === "yesno") {
    return (
      <CheckboxStyled key={field.name} className="container-field">
        {field.label && (
          <LabelStyled className="label-input">
            {field.label}
            <div className="d-flex flex-row align-items-center mt-3">
              <Checkbox
                name={field.name}
                checked={currentValue}
                type="checkbox"
                disabled={field.disabled}
                placeholder={field.placeholder}
                onBlur={handleBlur}
                onChange={(e: CheckboxChangeParams) => {
                  handleChange(field.name);
                  setCurrentValue(e.target.checked);
                  setFieldValue(field.name, e.target.checked);
                  if (field.onChange) {
                    field.onChange(e.target.value);
                  }
                }}
              />
              <span className="ms-2 me-3">Sim</span>

              <Checkbox
                name={field.name}
                checked={!currentValue}
                type="checkbox"
                disabled={field.disabled}
                placeholder={field.placeholder}
                onBlur={handleBlur}
                onChange={(e: CheckboxChangeParams) => {
                  handleChange(field.name);
                  setCurrentValue(!e.target.checked);
                  setFieldValue(field.name, !e.target.checked);
                  if (field.onChange) {
                    field.onChange(e.target.value);
                  }
                }}
              />
              <span className="ms-2">Não</span>
            </div>
          </LabelStyled>
        )}
        {errors[field.name] && (
          <ErrorStyled className="error-field-yesno">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </CheckboxStyled>
    );
  }

  if (field?.type === "number") {
    return (
      <FieldStyled className="container-field">
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        <NumberInputContainer disabled={field.disabled}>
          <ButtonInput
            type="button"
            onClick={() => {
              if (!field.disabled) {
                const t = (currentValue > 0 && currentValue - 1) || 0;
                setCurrentValue(t);
                setFieldValue(field.name, t);
              }
            }}
          >
            -
          </ButtonInput>
          <InputStyled
            value={currentValue}
            name={field.name}
            disabled={field.disabled}
            autoComplete={false}
            type="number"
            min={0}
            step={0.1}
            placeholder={field.placeholder}
            onBlur={handleBlur}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChange(field.name);
              setCurrentValue(e.target.value);
              setFieldValue(field.name, e.target.value);
              if (field.onChange) {
                field.onChange(e.target.value);
              }
            }}
          />
          <ButtonInput
            type="button"
            onClick={() => {
              if (!field.disabled) {
                const t = currentValue + 1 || 0;
                setCurrentValue(t);
                setFieldValue(field.name, t);
              }
            }}
          >
            +
          </ButtonInput>
        </NumberInputContainer>
        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldStyled>
    );
  }

  if (field?.type === "toggle") {
    return (
      <ToogleStyled key={field.name} className="container-field">
        {field.label && (
          <LabelStyled className="label-input">
            {field.label}
            <CheckboxToggle
              name={field.name}
              checked={currentValue}
              type="checkbox"
              hidden
              disabled={field.disabled}
              placeholder={field.placeholder}
              onBlur={handleBlur}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(field.name);
                setCurrentValue(e.target.checked);
                setFieldValue(field.name, e.target.checked);
                if (field.onChange) {
                  field.onChange(e.target.value);
                }
              }}
            />
            <div className="d-flex flex-row align-items-center mt-3">
              <ToogleButtonStyled className="toggle" />
              <span className="ms-2">{currentValue ? "Ativo" : "Inativo"}</span>
            </div>
          </LabelStyled>
        )}
        {errors[field.name] && (
          <ErrorStyled className="error-field-toggle">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </ToogleStyled>
    );
  }

  if (field?.type === "multipleValueText") {
    return (
      <FieldStyled className="container-field">
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        <ReactTags
          tags={tags}
          suggestions={[]}
          delimiters={delimiters}
          handleDelete={handleDelete}
          handleAddition={handleAddition}
          handleDrag={handleDrag}
          handleTagClick={handleTagClick}
          inputFieldPosition="top"
          placeholder="Digite e pressione enter"
          autocomplete
          classNames={{
            tagInput: "input-tag",
          }}
        />
        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldStyled>
    );
  }

  if (field?.type === "currency") {
    return (
      <FieldStyled className="container-field">
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        <InpuImasktStyled
          mask={Number}
          radix=","
          prefix="R$"
          thousandsSeparator="."
          value={currentValue?.toString()}
          placeholder={field.placeholder}
          disabled={field.disabled}
          onAccept={(value: any) => {
            handleChange(field.name);
            setCurrentValue(value);
            setFieldValue(field.name, value);
            if (field.onChange) {
              field.onChange(value);
            }
          }}
        />

        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldStyled>
    );
  }

  if (field.mask) {
    return (
      <FieldStyled className="container-field">
        {field.label && (
          <LabelStyled className="label-input" htmlFor={field.name}>
            {field.label}
            {field?.required && <span className="required">*</span>}
          </LabelStyled>
        )}
        <InpuImasktStyled
          mask={field.mask}
          id={field.name}
          value={currentValue?.toUpperCase()}
          placeholder={field?.placeholder}
          disabled={field.disabled}
          onAccept={(value: any) => {
            handleChange(field.name);
            setCurrentValue(value);
            setFieldValue(field.name, value);
            if (field.onChange) {
              field.onChange(value);
            }
          }}
        />

        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldStyled>
    );
  }
  if (field.type === "textarea") {
    return (
      <FieldStyled className="container-field">
        {field.type === "password" && (
          <ViewPass
            className="password-view"
            onClick={() => setViewPass((prev) => !prev)}
          >
            {viewPass ? (
              <RiEyeOffFill color={theme.colors.darkGray} />
            ) : (
              <RiEyeFill color={theme.colors.darkGray} />
            )}
          </ViewPass>
        )}
        {field.label && (
          <LabelStyled className="label-input">{field.label}</LabelStyled>
        )}
        <TextAreaStyled
          value={currentValue}
          name={field.name}
          disabled={field.disabled}
          rows={field?.rows}
          placeholder={field.placeholder}
          onBlur={handleBlur}
          onChange={(e: any) => {
            handleChange(field.name);
            setCurrentValue(e.target.value);
            setFieldValue(field.name, e.target.value);
            if (field.onChange) {
              field.onChange(e.target.value);
            }
          }}
        />
        {errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      </FieldStyled>
    );
  }

  return (
    <FieldStyled className="container-field">
      {field.type === "password" && (
        <ViewPass
          className="password-view"
          onClick={() => setViewPass((prev) => !prev)}
        >
          {viewPass ? (
            <RiEyeOffFill color={theme.colors.darkGray} />
          ) : (
            <RiEyeFill color={theme.colors.darkGray} />
          )}
        </ViewPass>
      )}
      {field.label && (
        <LabelStyled className="label-input" htmlFor={field.name}>
          {field.label}
          {field?.required && <span className="required">*</span>}
        </LabelStyled>
      )}
      <InputStyled
        value={currentValue}
        id={field.name}
        name={field.name}
        autoComplete="new-password"
        disabled={field.disabled}
        type={viewPass ? "text" : field.type}
        placeholder={field.placeholder}
        onBlur={handleBlur}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          handleChange(field.name);
          setCurrentValue(e.target.value);
          setFieldValue(field.name, e.target.value);
          if (field.onChange) {
            field.onChange(e.target.value);
          }
        }}
      />
      {field &&
        !field?.placeholder?.includes("Digite sua nova senha") &&
        !field?.placeholder?.includes("Digite sua nova senha novamente") &&
        errors[field.name] && (
          <ErrorStyled className="error-field">
            {errors[field.name]}
          </ErrorStyled>
        )}
      {field &&
        field.placeholder &&
        (field.placeholder.includes("Digite sua nova senha") ||
          field.placeholder.includes("Digite sua nova senha novamente")) &&
        errors[field.name] && (
          <ErrorStyledRecoveryPassword className="error-field">
            {errors[field.name]}
          </ErrorStyledRecoveryPassword>
        )}
    </FieldStyled>
  );
};
export default MakeField;
